// extracted by mini-css-extract-plugin
module.exports = {"mainBtn":"Button_mainBtn__rDaIN","secondaryBtn":"Button_secondaryBtn__Bx0fq"};